import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Link } from 'react-router-dom';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Container from '@material-ui/core/Container';
import { login } from "../api/auth";
import { useInput } from "../utils/useInputHook";
import { useAlert } from "react-alert";
import config from '../config';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Paper } from '@material-ui/core';
import { AccountAccessHelp } from "../components/AccountAccesHelp";

const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
    },
    paper: {
        padding: theme.spacing(2, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(5, 1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
        '& .MuiFormControl-root': {
            margin: theme.spacing(1, 0)
        }
    },
    submit: {
        margin: theme.spacing(2, 0, 2),
    },
}));


export default function LoginPage({ onLogin }) {
    const classes = useStyles();
    const alert = useAlert()
    const [loading, setLoading] = useState(false);
    const { value: username, bind: bindUsername } = useInput('');
    const [rememberMe, setRememberMe] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const { value: password, bind: bindPassword } = useInput('');

    const handleRememberMeChange = (event) => {
        setRememberMe(event.target.checked);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (loading)
            return;
        if (!username || !password) {
            return;
        }
        // make API call, get the userObject + token
        try {
            setLoading(true);
            const response = await login({ username, password });
            if (rememberMe) {
                localStorage.setItem('token', response.token)
                localStorage.setItem('user', JSON.stringify(response.user));
            }
            onLogin({ ...response.user, token: response.token })
        } catch (err) {
            alert.show(err.toString())
        } finally {
            setLoading(false);
        }
    }

    return (
        <Container component="main" maxWidth="xs" className={classes.wrapper}>
            <Paper className={classes.paper} elevation={4}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Sign in
                </Typography>
                <form className={classes.form} noValidate onSubmit={handleLogin}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="username">Username</InputLabel>
                        <OutlinedInput
                            variant="outlined"
                            required
                            fullWidth
                            id="email"
                            disabled={loading}
                            label="Username"
                            name="username"
                            autoComplete="email"
                            autoFocus
                            {...bindUsername}
                        />
                    </FormControl>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="password">Password</InputLabel>
                        <OutlinedInput
                            variant="outlined"
                            required
                            disabled={loading}
                            fullWidth
                            {...bindPassword}
                            name="password"
                            label="Password"
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            autoComplete="current-password"
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowPassword(s => !s)}
                                    >
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                    <FormControlLabel
                        control={<Checkbox value="remember" color="primary" checked={rememberMe} onChange={handleRememberMeChange} />}
                        label="Remember me"
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        {loading ? <CircularProgress color="inherit" className={classes.circularProgress} size={20} /> : 'Sign in'}
                    </Button>
                    <Link to="/forgot" style={{ textDecoration: 'none', display: 'block', width: '100%', color: '#555', textAlign: 'center', margin: 'auto' }}>Forgot password</Link>

                    {!config.HIDE_REGISTER_PAGE && 
                     <AccountAccessHelp
                        redirectTo="/register"
                        text="Don't have an account? Sign Up"
                    />}
                </form>
            </Paper>
        </Container>
    );
}
